<template>
  <v-container fluid class="fill-height">
    <v-row justify="center">
      <v-col cols="12">
        <v-card
            class="mx-auto"
            max-width="512"
            elevation="12"
            :loading="isLoading"
        >
          <v-card-title>
            Cambiar contraseña
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text>
            <p class="subtitle-1">
              Ingresa tu nueva contraseña para actualizarla.</p>
            <v-form
                ref="changePasswordForm"
                v-model="isValidForm"
                lazy-validation
            >
              <v-text-field
                  v-model="newPassword"
                  label="Nueva contraseña"
                  :type="showPassword ? 'text' : 'password'"
                  required
                  :rules="[rules.required, rules.password]"
                  prepend-inner-icon="mdi-lock-outline"
                  :append-icon="showPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                  @click:append="showPassword = !showPassword"
              />
              <v-text-field
                  v-model="confirmPassword"
                  label="Confirmar nueva contraseña"
                  :type="showConfirmPassword ? 'text' : 'password'"
                  required
                  :rules="[rules.required, rules.matchPassword(newPassword)]"
                  prepend-inner-icon="mdi-lock-check-outline"
                  :append-icon="showConfirmPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                  @click:append="showConfirmPassword = !showConfirmPassword"
              />
            </v-form>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-row>
              <v-col cols="12" sm="6" order="last" order-sm="first">
                <v-btn
                    color="secondary"
                    @click="$router.push('/inicio-de-sesion')"
                    block
                >
                  <v-icon left>mdi-close</v-icon>
                  Cancelar
                </v-btn>
              </v-col>
              <v-col cols="12" sm="6" order="first" order-sm="last">
                <v-btn
                    color="primary"
                    @click="changePassword"
                    :loading="isLoading"
                    :disabled="!isValidForm"
                    block
                >
                  <v-icon left>mdi-lock-reset</v-icon>
                  Cambiar contraseña
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue';
import ReturnButton from "@/components/buttons/ReturnButton.vue";
import throwErrorMessage from "@/utils/ErrorMessage";
import AuthService from "@/services/auth/AuthService";
import throwSuccessMessage from "@/utils/SuccessMessage";

export default Vue.extend({
  name: 'ChangePassword',
  components: {ReturnButton},
  data() {
    return {
      // Form fields
      newPassword: '',
      confirmPassword: '',

      // Token
      token: '',

      // State
      isLoading: false,
      isValidForm: false,
      showPassword: false,
      showConfirmPassword: false,

      // Validation
      rules: {
        required: (value: string) => !!value || 'Este campo es obligatorio.',
        password: (value: string) => {
          const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])[a-zA-Z\d\W_]{8,}$/;
          return pattern.test(value) || 'La contraseña debe tener al menos 8 caracteres, una mayúscula, una minúscula, un número y un símbolo';
        },
        matchPassword: (password: string) => (value: string) =>
            value === password || 'Las contraseñas no coinciden.',
      },
    };
  },
  methods: {
    async changePassword() {
      const form = this.$refs.changePasswordForm as any;
      if (!form.validate()) return;
      this.isLoading = true;
      try {
        const body = {
          token: this.token,
          newPassword: this.newPassword,
        };
        await AuthService.changePassword(body);
        await this.$router.push('/inicio-de-sesion');
        throwSuccessMessage('Contraseña actualizada exitosamente. Por favor, inicia sesión con tu nueva contraseña.');
      } finally {
        this.isLoading = false;
      }
    }
  },
  mounted() {
    const queryToken = this.$route.query.token;
    if (typeof queryToken === 'string') {
      this.token = queryToken;
    } else {
      throwErrorMessage('Enlace para cambiar contraseña inválido. Por favor, solicita un nuevo enlace.');
      this.$router.push('/forgot-password');
    }
  }
});
</script>

<style scoped>

</style>